/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ProfessionalExperienceEnum =
  (typeof ProfessionalExperienceEnum)[keyof typeof ProfessionalExperienceEnum];

export const ProfessionalExperienceEnum = {
  'groomer-more-than-one-year': 'groomer-more-than-one-year',
  'groomer-6-months-to-1-year': 'groomer-6-months-to-1-year',
  'groomer-3-months-to-6-months': 'groomer-3-months-to-6-months',
  'groomer-less-than-3-months': 'groomer-less-than-3-months',
  'bather-more-than-one-year': 'bather-more-than-one-year',
  'bather-6-months-to-1-year': 'bather-6-months-to-1-year',
  'bather-3-months-to-6-months': 'bather-3-months-to-6-months',
  'bather-less-than-3-months': 'bather-less-than-3-months',
  'in-training': 'in-training',
  'no-experience': 'no-experience',
} as const;
